// extracted by mini-css-extract-plugin
module.exports = {"root":"Root_root__3g0GA","pageContent":"Root_pageContent__14Mia"};